<prism-ui-page-content
  [illustrationUrl]="pageIllustrationUrl"
  [illustrationTop]="false">
  <div class="page-content" page-content>
    <div class="centerContainer">
      <img alt="sick-computer-" src="{{sickComputerUrl}}"/>
    </div>
    <div class="centerContainer">
    <prism-ui-heading
      slot="maintenance-header"
      key-id="maintenance-header"
      font-size="lg" 
      font-weight="regular" 
      is-uppercase="false"
      variant="default"
    >
      {{maintenanceContent.title}}
    </prism-ui-heading>
    </div>
    <div class="centerContainer maintenance">
      <prism-ui-copy key-id="maintenance-body" copyText="{{maintenanceContent?.body}}">
        <p [innerHTML]="maintenanceContent?.body"></p>
      </prism-ui-copy>
    </div>
  </div>
</prism-ui-page-content>
